/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Route
 */
export interface Route {
    /**
     * 
     * @type {string}
     * @memberof Route
     */
    departureIATA?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Route
     */
    departureIsCity?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Route
     */
    arrivalIATA?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Route
     */
    arrivalIsCity?: boolean;
    /**
     * 
     * @type {object}
     * @memberof Route
     */
    departureDate?: object | null;
    /**
     * 
     * @type {string}
     * @memberof Route
     */
    cabinClass?: string | null;
}

export function RouteFromJSON(json: any): Route {
    return RouteFromJSONTyped(json, false);
}

export function RouteFromJSONTyped(json: any, ignoreDiscriminator: boolean): Route {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'departureIATA': !exists(json, 'departureIATA') ? undefined : json['departureIATA'],
        'departureIsCity': !exists(json, 'departureIsCity') ? undefined : json['departureIsCity'],
        'arrivalIATA': !exists(json, 'arrivalIATA') ? undefined : json['arrivalIATA'],
        'arrivalIsCity': !exists(json, 'arrivalIsCity') ? undefined : json['arrivalIsCity'],
        'departureDate': !exists(json, 'departureDate') ? undefined : json['departureDate'],
        'cabinClass': !exists(json, 'cabinClass') ? undefined : json['cabinClass'],
    };
}

export function RouteToJSON(value?: Route | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'departureIATA': value.departureIATA,
        'departureIsCity': value.departureIsCity,
        'arrivalIATA': value.arrivalIATA,
        'arrivalIsCity': value.arrivalIsCity,
        'departureDate': value.departureDate,
        'cabinClass': value.cabinClass,
    };
}


